import React, { useEffect, useState } from 'react';
import ShippingView from './shipping/ShippingView';

import VoidLabelDialog from './shipping/VoidLabelDialog';
import { TaskName } from '../db/TaskClass';
import { restartPeriodicDbSync } from '../db/datamanager';

type ShippingTaskProps = {
  task: TaskName;
};

export default function ShippingTask({ task }: ShippingTaskProps) {
  useEffect(() => {
    restartPeriodicDbSync(task);
  }, []);

  const [voidLabelPopupVisible, setVoidLabelPopupVisible] = useState(false);

  return (
    <React.Fragment key={'shipping'}>
      <ShippingView showVoidLabelPopup={() => setVoidLabelPopupVisible(true)} />
      <VoidLabelDialog
        setVoidLabelPopupVisible={setVoidLabelPopupVisible}
        voidLabelPopupVisible={voidLabelPopupVisible}
      />
    </React.Fragment>
  );
}
